// TEIL 1: ALTER CODE (Thumbnails) - MUSS DRIN BLEIBEN!
if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        // Sicherheitscheck hinzugefügt
        if (!event.detail || !event.detail.currentElement || !event.detail.currentElement.dataset) {
          return;
        }
        
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

// TEIL 2: DOT NAVIGATION (NEU) - AM ENDE ANFÜGEN!
document.addEventListener('DOMContentLoaded', function() {
  
  const initDots = () => {
    const galleries = document.querySelectorAll('media-gallery');
    
    galleries.forEach(gallery => {
      const dotsContainer = gallery.querySelector('.product-media-dots');
      const slider = gallery.querySelector('.slider-mobile-gutter ul');
      
      if (!dotsContainer || !slider) return;
      
      dotsContainer.style.opacity = '0';
      dotsContainer.style.visibility = 'hidden';
      
      const generateDots = () => {
        const allSlides = slider.querySelectorAll('.slider__slide');
        const slides = Array.from(allSlides).filter(slide => 
          !slide.classList.contains('vz-hide')
        );
        
        const slideCount = slides.length;
        
        dotsContainer.innerHTML = '';
        for (let i = 0; i < slideCount; i++) {
          const dot = document.createElement('button');
          dot.className = 'media-dot' + (i === 0 ? ' active' : '');
          dot.dataset.mediaIndex = i;
          dot.setAttribute('aria-label', `Bild ${i + 1} anzeigen`);
          
          dot.addEventListener('click', (e) => {
            e.preventDefault();
            if (slides[i]) {
              slides[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
            }
          });
          
          dotsContainer.appendChild(dot);
        }
        
        requestAnimationFrame(() => {
          dotsContainer.style.opacity = '1';
          dotsContainer.style.visibility = 'visible';
        });
        
        const dots = dotsContainer.querySelectorAll('.media-dot');
        
        const updateDots = () => {
          const visibleSlides = Array.from(allSlides).filter(s => !s.classList.contains('vz-hide'));
          visibleSlides.forEach((slide, index) => {
            const rect = slide.getBoundingClientRect();
            const isVisible = rect.left >= 0 && rect.left < window.innerWidth / 2;
            if (isVisible && dots[index]) {
              dots.forEach(d => d.classList.remove('active'));
              dots[index].classList.add('active');
            }
          });
        };
        
        slider.removeEventListener('scroll', updateDots);
        slider.addEventListener('scroll', updateDots);
      };
      
      const waitForVariantFilter = () => {
        return new Promise((resolve) => {
          const checkSlides = () => {
            const hiddenSlides = slider.querySelectorAll('.slider__slide.vz-hide');
            if (hiddenSlides.length > 0 || document.querySelector('.product-variant-id')?.value) {
              resolve();
            } else {
              requestAnimationFrame(checkSlides);
            }
          };
          
          setTimeout(resolve, 300);
          checkSlides();
        });
      };
      
      waitForVariantFilter().then(() => {
        generateDots();
        
        const firstVisibleSlide = Array.from(slider.querySelectorAll('.slider__slide'))
          .find(slide => !slide.classList.contains('vz-hide'));
        if (firstVisibleSlide) {
          firstVisibleSlide.scrollIntoView({ behavior: 'auto', inline: 'start', block: 'nearest' });
        }
      });
      
      const produktAbschnitt = document.querySelector('.product-variant-id');
      if (produktAbschnitt) {
        produktAbschnitt.addEventListener('change', () => {
          dotsContainer.style.opacity = '0';
          
          setTimeout(() => {
            generateDots();
            
            const firstVisibleSlide = Array.from(slider.querySelectorAll('.slider__slide'))
              .find(slide => !slide.classList.contains('vz-hide'));
            if (firstVisibleSlide) {
            }
          }, 150);
        });
      }
      
      const observer = new MutationObserver(() => {
        generateDots();
      });
      
      observer.observe(slider, {
        attributes: true,
        attributeFilter: ['class'],
        subtree: true
      });
    });
  };
  
  if (document.readyState === 'complete') {
    setTimeout(initDots, 100);
  } else {
    window.addEventListener('load', () => {
      setTimeout(initDots, 100);
    });
  }
});
